import { render, staticRenderFns } from "./product-group-proItem.vue?vue&type=template&id=9de59e88&"
import script from "./product-group-proItem.vue?vue&type=script&lang=js&"
export * from "./product-group-proItem.vue?vue&type=script&lang=js&"
import style0 from "./product-group-proItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports